import type * as Blockly from "blockly";
import type { WorkspaceSvg } from "blockly";

import { useEditorState } from "@/store";

function listVariables(workspace: Blockly.Workspace) {
  return workspace
    .getVariableMap()
    .getAllVariables()
    .map((v) => ({
      id: v.getId(),
      name: v.getName(),
      type: v.getType(),
    }));
}

export function onAnyVariableChange(
  workspace: WorkspaceSvg,
  handler: (info: {
    type: string;
    id?: string;
    oldName?: string;
    newName?: string;
    varType?: string;
    vars: Array<{ id: string; name: string; type: string }>;
    raw: any;
  }) => void
) {

  const listener = (e: any) => {
    if (e.isUiEvent) return;

    if (
      e.type === window.Blockly.Events.VAR_CREATE ||
      e.type === window.Blockly.Events.VAR_DELETE ||
      e.type === window.Blockly.Events.VAR_RENAME
    ) {
      handler({
        type: e.type,
        id: e.varId,
        oldName: e.oldName,
        newName: e.newName,
        varType: e.varType,
        vars: listVariables(workspace),
        raw: e,
      });
      useEditorState.getState().setBlocklyVariables({
        scope: useEditorState.getState().blocklyCodePath,
        state: "variables",
        newData: listVariables(workspace),
      });
    }
  };

  workspace.addChangeListener(listener);
  handler({ type: "init", vars: listVariables(workspace), raw: null });

  return () => workspace.removeChangeListener(listener);
}
